/**
 * 公共翻译 - 中文
 * Common translations - Chinese
 */
export const commonZh = {
  // 通用导航
  overview: '概览',
  dashboard: '仪表盘',
  admin: '管理',
  settings: '设置',

  // 通用操作
  create: '创建',
  creating: '创建中...',
  edit: '编辑',
  delete: '删除',
  deleting: '删除中...',
  save: '保存',
  saving: '保存中...',
  saveChanges: '保存更改',
  cancel: '取消',
  confirm: '确认',
  submit: '提交',
  reset: '重置',
  search: '搜索',
  filter: '筛选',
  selected: '已选',
  export: '导出',
  import: '导入',
  download: '下载',
  upload: '上传',
  refresh: '刷新',
  back: '返回',
  backToList: '返回列表',
  next: '下一步',
  previous: '上一步',
  first: '首先',
  previousPage: '上一页',
  nextPage: '下一页',
  close: '关闭',
  view: '查看',
  viewAll: '查看全部',
  details: '详情',
  viewDetails: '查看详情',
  preview: '预览',
  actions: '操作',
  attributes: '属性',
  quickActions: '快捷操作',
  clear: '清空',
  clearSearch: '清除搜索',
  from: '来自',
  filtered: '中筛选',
  confirmRemove: '确认移除',
  pinned: '固定',
  templateDownloaded: '模板已下载',
  fileParseError: '文件解析失败',
  noValidData: 'Excel文件中没有有效数据',
  manualRestore: '手动恢复',
  restoreSuccess: '用户恢复成功',
  restoreFailed: '恢复用户失败',
  batchUpdateFailed: '批量修改失败',
  removeFailed: '移除失败',
  members: '成员',
  addFailed: '添加失败',
  primary: '主要',
  updating: '修改中...',
  confirmUpdate: '确认修改',
  downloadTemplate: '下载模板',
  importing: '导入中...',
  startImport: '开始导入',
  restoring: '恢复中...',
  confirmRestore: '确认恢复',
  importFailed: '批量导入失败',
  searching: '搜索中...',
  noUsers: '未找到用户',
  noMatchingUsers: '未找到匹配用户',
  add: '添加',
  setFailed: '设置失败',
  checkingPermission: '验证权限中...',

  // 预览
  previewTitle: '交互反馈样式预览',
  previewDescription: '用于对比通知与确认框的状态样式',
  previewToastSection: '通知样式',
  previewToastHint: '点击按钮在右上角预览通知样式',
  previewDialogSection: '确认框样式',
  previewDialogHint: '高风险操作确认示例',
  previewToastSuccessTitle: '操作成功',
  previewToastSuccessDesc: '已保存更改',
  previewToastErrorTitle: '操作失败',
  previewToastErrorDesc: '请检查输入后重试',
  previewToastWarningTitle: '注意',
  previewToastWarningDesc: '此操作将影响其他成员',
  previewToastInfoTitle: '提示',
  previewToastInfoDesc: '系统正在处理请求',
  previewToastLoadingTitle: '处理中',
  previewToastLoadingDesc: '正在同步数据',
  previewToastNeutralTitle: '已刷新',
  previewToastNeutralDesc: '列表数据已更新',
  previewToastActionTitle: '需要处理',
  previewToastActionDesc: '已有变更等待确认',
  previewToastActionLabel: '查看',
  previewDialogOpen: '打开删除确认框',
  previewDialogTitle: '确认删除该部门？',
  previewDialogDesc: '该操作不可撤销，将删除部门及其成员关联信息。',
  previewDialogConfirm: '确认删除',
  previewSystemTitle: '全局反馈样式预览',
  previewSystemDesc: '用于校验弹窗、空态、校验与顶部横幅',
  previewConfirmSection: '确认弹窗',
  previewConfirmHint: '展示高风险与常规确认两种样式',
  previewConfirmDangerOpen: '打开危险确认框',
  previewConfirmPrimaryOpen: '打开常规确认框',
  previewConfirmDangerTitle: '确认删除成员？',
  previewConfirmDangerDesc: '删除后无法恢复，将移除成员关联信息。',
  previewConfirmDangerAction: '删除成员',
  previewConfirmPrimaryTitle: '确认保存变更？',
  previewConfirmPrimaryDesc: '将更新该成员的部门与角色设置。',
  previewConfirmPrimaryAction: '保存变更',
  previewBannerSection: '顶部横幅提示',
  previewBannerHint: '用于系统维护或重要公告',
  previewBannerMaintenanceTitle: '系统维护通知',
  previewBannerMaintenanceDesc: '今晚 23:00 - 02:00 将进行维护，期间服务可能受影响。',
  previewBannerNoticeTitle: '重要公告',
  previewBannerNoticeDesc: '组织架构功能新增批量导入能力，欢迎体验。',
  envBannerUatTitle: '测试环境',
  envBannerUatDesc: '当前为测试环境，仅用于功能验证，请勿提交正式数据。',
  envBannerDevTitle: '开发环境',
  envBannerDevDesc: '当前为开发环境，仅用于功能验证。',
  previewPageStateSection: '页面级状态',
  previewPageStateHint: '错误页与空态示例',
  previewPageErrorTitle: '页面加载失败',
  previewPageErrorDesc: '请检查网络后刷新页面或稍后再试。',
  previewPageEmptyTitle: '暂无数据',
  previewPageEmptyDesc: '当前条件下没有匹配结果。',
  previewValidationSection: '表单校验反馈',
  previewValidationHint: '输入框错误、警告与成功状态',
  previewValidationFieldError: '成员姓名',
  previewValidationFieldWarning: '成员编号',
  previewValidationFieldSuccess: '成员邮箱',
  previewValidationPlaceholder: '请输入内容',
  previewValidationErrorText: '该字段为必填项',
  previewValidationWarningText: '格式可能不符合规范',
  previewValidationSuccessText: '校验通过',
  
  // 状态
  status: '状态',
  active: '启用',
  inactive: '禁用',
  enabled: '已启用',
  disabled: '已禁用',
  draft: '草稿',
  published: '已发布',
  archived: '已归档',
  pending: '待处理',
  approved: '已批准',
  rejected: '已拒绝',
  completed: '已完成',
  inProgress: '进行中',
  cancelled: '已取消',
  removing: '移除中...',
  
  // 时间
  time: '时间',
  today: '今天',
  yesterday: '昨天',
  tomorrow: '明天',
  thisWeek: '本周',
  lastWeek: '上周',
  thisMonth: '本月',
  lastMonth: '上月',
  thisYear: '今年',
  createdAt: '创建时间',
  updatedAt: '更新时间',
  startDate: '开始日期',
  endDate: '结束日期',
  
  // 用户相关
  user: '用户',
  users: '用户',
  username: '用户名',
  password: '密码',
  email: '邮箱',
  phone: '电话',
  role: '角色',
  roles: '角色',
  permissions: '权限',
  profile: '个人资料',
  logout: '退出登录',
  
  // 数据
  name: '名称',
  description: '描述',
  pleaseSelect: '请选择...',
  otherSettings: '其他设置',
  type: '类型',
  category: '分类',
  tags: '标签',
  remark: '备注',
  required: '必填',
  optional: '可选',
  fullTime: '全职',
  partTime: '兼职',
  
  // 消息提示
  success: '成功',
  error: '错误',
  invalidInput: '无效输入',
  warning: '警告',
  info: '信息',
  loading: '加载中...',
  loadFailed: '加载失败',
  retry: '重试',
  noData: '暂无数据',
  noResults: '无搜索结果',
  noMatchingResults: '未找到匹配结果',
  tryOtherKeywords: '请尝试其他关键词',
  noAlerts: '暂无预警',
  confirmDelete: '确定要删除吗？',
  deleteWarning: '此操作无法撤销',
  operationSuccess: '操作成功',
  operationFailed: '操作失败',
  saveSuccess: '保存成功',
  saveFailed: '保存失败',
  deleteSuccess: '删除成功',
  deleteFailed: '删除失败',
  createSuccess: '创建成功',
  createFailed: '创建失败',
  updateSuccess: '更新成功',
  updateFailed: '更新失败',
  
  // API 错误
  requestFailed: '请求失败',
  serverError: '服务器错误，请稍后重试',
  networkError: '网络连接失败，请检查网络设置',
  unknownError: '未知错误',
  noPermissionOperation: '您没有权限执行此操作',
  permissionInsufficientDetail: '权限不足: 您没有此操作所需的权限。请联系管理员授权。',
  
  // 分页
  page: '页',
  of: '共',
  pageOf: '页，共',
  pages: '页',
  pageSize: '每页条数',
  total: '共',
  items: '条',
  showingItems: '显示 {start} 到 {end} 条，共 {total} 条',
  totalRecords: '共 {total} 条记录',
  currentPage: '第 {current} / {total} 页',
  prevPage: '上一页',
  
  // 表单验证
  requiredField: '此字段为必填项',
  invalidEmail: '邮箱格式不正确',
  invalidPhone: '手机号格式不正确',
  invalidUrl: '链接格式不正确',
  minLength: '最少 {min} 个字符',
  maxLength: '最多 {max} 个字符',
  minValue: '最小值为 {min}',
  maxValue: '最大值为 {max}',
  
  // 其他
  all: '全部',
  none: '无',
  noPermission: '没有权限',
  permissionDeniedDetail: '您没有权限访问此页面，请联系管理员',
  select: '请选择',
  yes: '是',
  no: '否',
  unknown: '未知',
  other: '其他',
  more: '更多',
  less: '收起',
  expand: '展开',
  collapse: '折叠',
  selectAll: '全选',
  deselectAll: '取消全选',
  copySuccess: '复制成功',
  copyFailed: '复制失败',
  submitting: '提交中...',
  copy: '复制',
  expandAll: '全部展开',
  collapseAll: '全部收起',
  permissionDenied: '权限不足',
  
  // 其他补充
  or: '或',
  notAvailable: '不可用',
  submitter: '提交人',
  submitTime: '提交时间',
  manualInput: '手动输入',
  manage: '管理',
  
  // 表单验证和导航确认
  validationFailed: '表单验证失败',
  confirmLeave: '确认离开',
  unsavedChangesWarning: '您有未保存的更改，确定要离开吗？',
  stay: '留下',
  leave: '离开',
  selectDepartmentFirst: '请先选择部门',
  remove: '移除',
  selectDepartment: '选择部门',
  selectPosition: '选择岗位',
  selectManager: '选择主管',
  update: '更新',
  
  // Additional common keys
  justNow: '刚刚',
  hoursAgo: '小时前',
  daysAgo: '天前',
  unassigned: '未分配',
  uncategorized: '未分类',
  noOrganizationBanner: '您还没有组织归属，大部分功能无法使用。请联系管理员将您加入组织。',
  noOrganizationToastTitle: '未识别到组织上下文',
  noOrganizationToastDescription: '您当前没有可用的组织归属，无法发起需要组织上下文的请求。请联系管理员将您加入组织。',
};

export type CommonTranslations = typeof commonZh;
